import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

// Core
import { AuthProvider, ProtectedRoute } from './core';
import { ThemeProvider } from './core/theme/ThemeContext';

// Features
import Login from './features/authentication/Login';
import TodoList from './features/todos/TodoList';
import Reminders from './features/reminders/Reminders';
import ReminderCategories from './features/reminders/ReminderCategories';
import Orders from './features/orders/Orders';
import ShopOrders from './features/orders/ShopOrders';
import SasheOrders from './features/orders/SasheOrders';
import Users from './features/users/Users';
import Sales from './features/sales/Sales';
import ActivityLogs from './features/activity-logging/ActivityLogs';
import Sashe from './features/sashe/Sashe';
import SasheSettings from './features/sashe/SasheSettings';
import SasheHistory from './features/sashe/SasheHistory';
import CryptoPortfolio from './features/crypto/CryptoPortfolio';

// Pages (not feature-specific)
import Dashboard from './pages/Dashboard';
import Notes from './pages/Notes';
import Calendar from './pages/Calendar';
import Settings from './pages/Settings';
import Tools from './pages/Tools';

// Shared Components
import Layout from './shared/components/Layout';
import ErrorBoundary from './shared/components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <div className="App">
              <ToastContainer position="top-right" theme="colored" />
              <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />

              {/* Protected Routes */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Navigate to="/dashboard" replace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Dashboard />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/todolist"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <TodoList />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reminders"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Reminders />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reminder-categories"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ReminderCategories />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/orders"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Orders />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/shop-orders"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ShopOrders />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sashe-orders"
                element={
                  <ProtectedRoute requirePermission="orders">
                    <Layout>
                      <SasheOrders />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notes"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Notes />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/calendar"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Calendar />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sashe"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Sashe />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sashe-settings"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <SasheSettings />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sashe-history"
                element={
                  <ProtectedRoute requirePermission="sashe">
                    <Layout>
                      <SasheHistory />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Settings />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tools"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Tools />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <ProtectedRoute requirePermission="users">
                    <Layout>
                      <Users />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sales"
                element={
                  <ProtectedRoute requirePermission="sales">
                    <Layout>
                      <Sales />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/activity-logs"
                element={
                  <ProtectedRoute requirePermission="activity_logs">
                    <Layout>
                      <ActivityLogs />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/crypto"
                element={
                  <ProtectedRoute requirePermission="crypto">
                    <Layout>
                      <CryptoPortfolio />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              </Routes>
            </div>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
